import { get, set, omit } from 'lodash';
import store from '../store/Store';

const unique2global = {
    'lotaltyPoints.color': 'message.success.color',
    'lotaltyPoints.fontWeight': 'font.bold',
    'productIcons.colorHighlight': 'message.success.color',
    'grid.head.background': 'background.style3',
    'grid.head.color': 'font.colorAlternate',
    'grid.head.fontSize': 'font.smallerSize',
    'grid.head.fontWeight': 'font.normalWeight',
    'grid.row.background': 'background.style1',
    'grid.row.color': 'font.color',
    'grid.row.fontWeight': 'font.normalWeight',
    'grid.row.border': 'border.color.style2',
    'urgencyTrigger.inline.color': 'message.error.color',
    'input.label.font': 'font.main',
    'input.label.weight': 'font.normalWeight',
    'input.label.color': 'input.color',
    'input.label.size': 'font.smallerSize',
    'input.checkboxAndRadio.disabledText': 'font.colorLight',
    'link.color.default': 'font.color',
    'link.color.focus': 'link.color.normal',
    'link.underline.default.color': 'link.color.normal',
    'link.underline.hover.color': 'link.color.hover',
    'link.underline.focus.color': 'link.color.normal',
    'link.underline.active.color': 'link.color.active',
    'calendar.dot.color': 'message.success.color',
    'calendar.tooltip.background': 'background.style3',
    'calendar.tooltip.border': 'font.colorAlternate',
    'calendar.tooltip.color': 'font.colorAlternate'
};

/**
 * Helper function to map theme json path to store paths
 * @param path
 * @returns {string}
 */
function internalStoreStateRouter(path) {
    const parts = path.split('.');
    if (path.startsWith('header.progressIndicator.') || path.startsWith(`colors.`) || path.startsWith(`form.`)) {
        return parts.slice(1).join('.');
    } else {
        return path;
    }
}
function internalStoreStateRouterInv(path) {
    if (path.startsWith('progressIndicator.')) {
        return `header.${path}`;
    } else if (path.startsWith('message.') || path.startsWith('background.') || path.startsWith('border.')) {
        return `colors.${path}`;
    } else if (path.startsWith('input.')) {
        return `form.${path}`;
    } else {
        return `global.${path}`;
    }
}

export function filterThemeUniqueGlobal(theme) {
    Object.entries(unique2global).forEach(([uniqueKey, globalKey]) => {
        set(theme, uniqueKey, uniqueGlobalFilterNR(uniqueKey, get(theme, uniqueKey), theme));
    });

    // do a hack here to deal with populating values for keys with abnormal naming
    const backgroundStyle2 = get(theme, 'background.style2', '');
    const gridRow = get(theme, 'grid.row');
    gridRow['background.hover'] = backgroundStyle2;
    return theme;
}
export function uniqueGlobalFilterNR(uniquePath, value, currentTheme = get(store.getState(), 'app.data.theme')) {
    if (value === undefined || value === '' || value === null) {
        const mappedPath = get(unique2global, [uniquePath]);
        return get(currentTheme, mappedPath, value);
    } else {
        return value;
    }
}
export function uniqueGlobalFilter(uniquePath, value, currentTheme = get(store.getState(), 'app.data.theme')) {
    if (value === undefined || value === '' || value === null) {
        const mappedPath = get(unique2global, [internalStoreStateRouter(uniquePath)]);
        return get(currentTheme, internalStoreStateRouterInv(mappedPath), value);
    } else {
        return value;
    }
}



// WEBPACK FOOTER //
// ./src/constants/uniqueKeyToGlobalMap.js